// extracted by mini-css-extract-plugin
export default {"cityRow":"CityCard_cityRow__mGXjK","cityName":"CityCard_cityName__chilU","cityUsers":"CityCard_cityUsers__psdaQ"};